// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".background-authen[data-v-524657e1] {\n  background: url(\"/admin-static/auth-bg-image-1.svg\") center center no-repeat;\n  height: 80%;\n  background-position: center;\n  background-repeat: repeat;\n  background-size: contain;\n}\n.pureground-authen[data-v-524657e1] {\n  background: url(\"/admin-static/auth-bg-image-2.svg\") center center no-repeat;\n  background-size: cover;\n}", ""]);
// Exports
module.exports = exports;
